import { ReactNode } from "react";

type Step = {
  title: ReactNode;
  description?: ReactNode;
  content?: ReactNode;
};

type NumberedStepsProps = {
  steps: Step[];
};

export function NumberedSteps({ steps }: NumberedStepsProps) {
  return (
    <div className="flex flex-col gap-2">
      {steps.map((step, index) => (
        <div key={index} className="flex gap-4">
          <div className="flex flex-col items-center">
            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-bg-faint text-fg-base font-medium text-sm">
              {index + 1}
            </div>
            {index < steps.length - 1 && (
              <div className="grow w-[3px] rounded-full mt-2 bg-border-base"></div>
            )}
          </div>
          <div className="flex-1 pb-6">
            <h3 className="text-md font-medium mb-1">{step.title}</h3>
            {step.description && (
              <p className="text-fg-muted mb-2">{step.description}</p>
            )}
            <div
              onClick={(e) => {
                const target = e.target as HTMLElement;
                if (target.closest('[aria-disabled="true"]')) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            >
              {step.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
